import React from 'react';
import { HeaderWrapper } from './styled';
import MenuBar from './MenuBar';
import MenuLeft from './MenuLeft';

function Header() {
  return (
    <HeaderWrapper theme="light">
      <MenuBar />
      <MenuLeft />
    </HeaderWrapper>
  );
}

export default Header;
